import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      const accent = this.props.accentColor || '#7aa2f7';
      return (
        <div style={{
          padding: 40,
          color: '#f7768e',
          background: 'var(--bg-primary, #1a1b26)',
          minHeight: '100vh',
          fontFamily: 'var(--font-mono, monospace)',
        }}>
          <h1 style={{ color: 'var(--text-primary, #c0caf5)', fontSize: 18 }}>
            {this.props.title || 'Fehler'}
          </h1>
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: 13, marginTop: 16, color: '#e0af68' }}>
            {this.state.error?.message}
          </pre>
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: 11, marginTop: 8, color: '#565f89', maxHeight: 200, overflow: 'auto' }}>
            {this.state.error?.stack}
          </pre>
          <div style={{ display: 'flex', gap: 8, marginTop: 20 }}>
            <button
              onClick={() => window.history.back()}
              style={{
                padding: '8px 16px', background: 'var(--bg-tertiary, #24283b)',
                color: 'var(--text-primary, #c0caf5)', border: '1px solid var(--border, #24283b)',
                borderRadius: 6, cursor: 'pointer', fontSize: 12,
              }}
            >
              ← Zurueck
            </button>
            <button
              onClick={() => { this.setState({ error: null }); window.location.href = '/'; }}
              style={{
                padding: '8px 16px', background: accent,
                color: '#1a1b26', border: 'none', borderRadius: 6, cursor: 'pointer',
                fontWeight: 600, fontSize: 12,
              }}
            >
              Zur Uebersicht
            </button>
            <button
              onClick={() => { this.setState({ error: null }); window.location.reload(); }}
              style={{
                padding: '8px 16px', background: 'transparent',
                color: accent, border: `1px solid ${accent}40`,
                borderRadius: 6, cursor: 'pointer', fontSize: 12,
              }}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
